import { render, staticRenderFns } from "./AgenciesList.vue?vue&type=template&id=0bda3f20&"
import script from "./AgenciesList.vue?vue&type=script&lang=js&"
export * from "./AgenciesList.vue?vue&type=script&lang=js&"
import style0 from "./AgenciesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports